import React, {
  ReactElement, useEffect, useRef, useState,
} from 'react';
import { Col, InsetText, Row } from 'idsk-react-components';
import { useLocation, useNavigate, useParams } from 'react-router';
import SprievodnyDokumentListTable from './component/SprievodnyDokumentListTable';
import './sprievodnyDokumentList.scss';
import DownloadSprievodnyDokumentListButton
  from '../component/DownloadSprievodnyDokumentListButton';
import StadiumMaterialuSelect from '../component/StadiumMaterialuSelect';
import LegislativnyMaterialDetail
  from '../../../model/legislativnyMaterial/LegislativnyMaterialDetail';
import errorIcon from '../../../../assets/images/icon-error-red.svg';
import StadiumMaterialuHistoriaList
  from '../../../model/legislativnyMaterial/StadiumMaterialuHistoriaList';
import {
  currentStadiumEqualsLatest,
  getInitialStadium,
  isLatestStadium,
} from '../../../function/getLatestStadium';
import { useUserContext } from '../../../context/UserContext';
import getSprievodnyDokumentRoute from '../../../function/sprievodnyDokumentRoute';

interface Props {
  materialDetail: LegislativnyMaterialDetail;
  legMaterialHistoriaList: StadiumMaterialuHistoriaList;
}

const SprievodnyDokumentList = ({
  materialDetail,
  legMaterialHistoriaList,
}: Props): ReactElement => {
  const { search } = useLocation();
  const stadiumUuidSearchParam = new URLSearchParams(search).get('stadiumUuid');
  const [selectedStadium, setSelectedStadium] = useState(
    getInitialStadium(legMaterialHistoriaList, stadiumUuidSearchParam),
  );
  const [documentsExists, setDocumentsExists] = useState<boolean>(false);
  const stickyElement = useRef<HTMLDivElement>();
  const [startingOffset, setStartingOffset] = useState<number>(0);

  const navigate = useNavigate();
  const { pouzivatel } = useUserContext();
  const {
    type,
    year,
    index,
    // @ts-ignore
  } = useParams<{ type: string, year: number, index: number }>();

  useEffect(() => {
    if (legMaterialHistoriaList && materialDetail) {
      navigate(getSprievodnyDokumentRoute(
        pouzivatel,
        materialDetail?.hasOpravnenieSprievodneDokumenty,
        currentStadiumEqualsLatest(materialDetail?.stadium?.hodnota, legMaterialHistoriaList?.historiaRecords),
        isLatestStadium(legMaterialHistoriaList, selectedStadium),
        selectedStadium.uuid,
        type,
        year,
        index,
      ));
    }
  }, [index, legMaterialHistoriaList, materialDetail, navigate, pouzivatel, selectedStadium, type, year]);

  useEffect(() => {
    if (stickyElement.current !== undefined) {
      setStartingOffset(stickyElement.current.offsetTop);
    }
  }, []);

  return (
    <div className="sprievodny-dokument-list">
      {!isLatestStadium(legMaterialHistoriaList, selectedStadium) && (
        <Row>
          <Col>
            <div className="sticky-element" data-offset={startingOffset} ref={stickyElement}>
              <InsetText
                type="warn"
                className="non-actual-sprievodny-dokument-list__message"
                icon={errorIcon}
              >
                Prezeráte si neaktuálnu (archívnu) verziu dokumentov.
              </InsetText>
            </div>
          </Col>
        </Row>
      )}
      <Row>
        <Col width="one-half">
          <StadiumMaterialuSelect
            materialDetail={materialDetail}
            selectedStadium={selectedStadium}
            setSelectedStadium={setSelectedStadium}
            legMaterialHistoriaList={legMaterialHistoriaList}
          />
        </Col>
        <Col width="one-half">
          {documentsExists && (
            <DownloadSprievodnyDokumentListButton
              legMaterialUuid={materialDetail.uuid}
              stadiumUuid={selectedStadium.uuid}
            />
          )}
        </Col>
      </Row>
      {selectedStadium?.uuid && (
        <SprievodnyDokumentListTable
          legMaterialUuid={materialDetail.uuid}
          selectedStadiumUuid={selectedStadium.uuid}
          setDocumentsExists={setDocumentsExists}
        />
      )}
    </div>
  );
};

export default SprievodnyDokumentList;
